goog.provide('el8.app.shared.dialog.survey');

goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.app.shared.dialog.survey');
goog.require('el8.uiwidget.nonAlarmingAlert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');

//
// In-app Survey
//
// Note: the NPS survey type is a special case where we have a bundle of (only) three questions.
// First, a 0-10 scale, then when the user selects a value, we show one of two initially-hidden
// textareas for them to provide additional details.
//
// The popupNotification type shows a simple text message in the dialog content
el8.app.shared.dialog.survey = (function() {
    var DEBUG = false;
    var surveyDefinition = {};
    var notification_id = null;
    var actionsMenu = null;
    var isNPS = false;
    var isPopupNotification = false;

    // create the FormDialog
    var that = new el8.uiwidget.FormDialog({
        width: 660,
        autoHeight: true,
        position: {'my': 'center'}, // make sure it's centered (see note in NewDialog)
        contentFn: function() {
            return el8.template.app.shared.dialog.survey.content();
        }
    });

    that._createForm = function () {
        var fields = [];

        if (surveyDefinition.questions.length === 0) {
            isPopupNotification = true;
        }

        _(surveyDefinition.questions).each(function (q, i) {
            if (q.type === 'nps') { isNPS = true; }

            var f = _(q).extend({
                // note: the field itself is passed to the tmplFn
                name: surveyDefinition.name+'_q_'+i,    // required for getMapped()
                questionId: surveyDefinition.name+'_q_'+i,
                hidden: (isNPS && (i > 0)) ? true : false,
                tmplFn: el8.template.app.shared.dialog.survey[q.type]
            });

            fields.push(f);
        });

        var form = new el8.uiwidget.Form({fields: fields, noFirstFocus: true});

        if (isPopupNotification) {
            form.addButton('send', 'Ok', that._sendHandler, true);
        } else {
            form.addButton('send', 'Send', that._sendHandler, true);
            form.addButton('showLater', 'Show later', function() { that.hide(); }, false);
        }
        that.setForm(form);
    };

    that._sendHandler = function () {
        that.getForm().disable();
        var form = that.getForm();

        if (!DEBUG) {
            $.el8_ajax({
                url: el8.service.urls.get('survey', [notification_id]),
                type: 'POST',
                data: JSON.stringify({
                    survey_name: surveyDefinition.name,
                    answers: form.getMapped()
                }),
                success: function() {
                    // only show postSubmitText if set
                    if (surveyDefinition['postSubmitText']) {
                        el8.uiwidget.nonAlarmingAlert(surveyDefinition['postSubmitText']);
                    }
                    that.hide();
                },
                error: function() { that.getForm().enable(); }
            });
        } else {
            that.hide();
        }
    };

    that._remindLaterOrNever = function(reminderWhen) {
        $.el8_ajax({
            url: el8.service.urls.get('deferrableUserNotification', [notification_id]),
            type: 'POST',
            data: JSON.stringify({
                remind_later: reminderWhen,
                local_time: el8.service.tz.asServerFormatDateTime((el8.service.tz.computerLocalNow()))
            })
        });
        that.hide();
    };

    that._initActionsMenu = function() {
        actionsMenu = new el8.uiwidget.NewActionsMenu({
            container: that.getDialogContainer(),
            anchorTop: that.getDialogContainer(),
            menuId: 'remind-later-dropdown',
            width: 185
        });
    };

    that._populateActionsMenu = function() {
        // creates the action menu items based on the user's local time
        var menu = [];

        var computerLocalHours = (el8.service.tz.computerLocalNow()).getHours();
        if (computerLocalHours > 4 && computerLocalHours < 18) {
            menu.push({
                actionText: 'Remind me tonight',
                actionFn: function() { that._remindLaterOrNever('tonight'); }
            });
        }
        menu = menu.concat([
            {
                actionText: 'Remind me tomorrow',
                actionFn: function() { that._remindLaterOrNever('tomorrow'); }
            },
            {
                actionText: "Don't show this again",
                actionFn: function() { that._remindLaterOrNever('never'); }
            }
        ]);

        return menu;
    };

    that._bindTriggers = function () {
        that.getContentElt()
            .on('click', '.remind-dropdown-trigger',  function() {
                actionsMenu.display($(this),
                                    null,
                                    { top: 24, left: 124 },
                                    that._populateActionsMenu());
                return false; // must return false
            })
            .on('click', '.hide-trigger',  function() {
                that.hide();
            });

            if (isNPS) {
                var clickFn = function(e) {
                    if (e.target.value < 9) {
                        that.getContentElt().find('.survey-freetext').first().show();
                        that.getContentElt().find('.survey-freetext').last().hide();
                        that.getForm().focusField(surveyDefinition.name+'_q_1');
                    } else {
                        that.getContentElt().find('.survey-freetext').first().hide();
                        that.getContentElt().find('.survey-freetext').last().show();
                        that.getForm().focusField(surveyDefinition.name+'_q_2');
                    }
                    that.adjustHeight();
                };

                for (var i = 0; i < 11; i++) {
                    var radioId = '#'+surveyDefinition.name+'_q_0_'+i;
                    that.getContentElt().on('click', radioId, clickFn);
                }
            }
    };

    that._noteStarted = function () {
        $.el8_ajax({
            url: el8.service.urls.get('deferrableUserNotification', [notification_id]),
            type: 'POST',
            data: JSON.stringify({
                started: true,
                local_time: el8.service.tz.asServerFormatDateTime((el8.service.tz.computerLocalNow()))
            })
        });
    };

    var super_show = that.show;
    that.show = function(data) {
        surveyDefinition = data['survey'];
        notification_id = data['id'];

        // if this has been loaded before, clear the content for the new form
        if (that.getForm()) {
            that.setContent(el8.template.app.shared.dialog.survey.content());
        }

        that._createForm();
        super_show.call(that);  // renders form

        if (isPopupNotification) {
            that.setContent(
                el8.template.app.shared.dialog.survey.notificationContent({
                    text: surveyDefinition['text'] || '',
                    link: surveyDefinition['link'] || '',
                    linkText: surveyDefinition['linkText'] || ''
                })
            );
        }

        that.setTitle(surveyDefinition['title']);

        that._initActionsMenu();
        that._bindTriggers();

        that.adjustPosition();

        that._noteStarted();

    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);

        // manually undelegate this handler, since NewActionsMenu doesn't on destroy
        that.getDialogContainer().off('click', '#remind-later-dropdown');
        that.getContentElt().off('click', '.remind-dropdown-trigger')
                            .off('click', '.hide-trigger');

        actionsMenu.destroy();

        actionsMenu = null;
        surveyDefinition = {};
        notification_id = null;
    };

    that.poll = function() {
        $.el8_ajax({
            url: el8.service.urls.get('deferrableUserNotification'),
            timeout: 5*1000, // 5 seconds max
            data: { local_time: el8.service.tz.asServerFormatDateTime((el8.service.tz.computerLocalNow())) },
            success: function(data) {
                if (!data) {
                    if (that.isOpen()) { that.hide(); } // started in another tab
                    return; // or nothing to do
                }
                if (!that.isOpen()) { that.show(el8.util.keysFromUnderscoreToCamel(data)); }
            },
            error_override: function() {}
        });
    };

    return that;

})();
